export const POST_NUMBER_LENGTHS = {
  'NO': '9999'.length,
  'SE': '999-99'.length
};

export const POST_NUMBER_NO_SPACES_LENGTHS = {
  'NO': '9999'.length,
  'SE': '99999'.length
};

export const ORG_NUMBER_NO_SPACE_LENGTHS = {
  'NO': '999 999 999',
  'SE': '999999-9999'
};

export const ORG_NUMBER_LENGTHS = {
  'NO': '999 999 999'.length,
  'SE': '999999-9999'.length
};

export enum DOMAIN_NAMES {
  NO = 'no',
  SE = 'se',
}

export const COUNTRIES = {
  NORWAY: 'NO',
  SWEDEN: 'SE'
};

export const COUNTRY_CODES = {
  'NO': 'NORWAY',
  'SE': 'SWEDEN'
};

export const COUNTRY_CODE_LOCALE_CODE = {
  'NO': 'no',
  'EN': 'en',
  'SE': 'sv'
};

export enum COUNTRY_CODE {
  NO = 'NO',
  SE = 'SE'
}

export enum COUNTRY_BY_CODE {
  NO = 'Norge',
  SE = 'Swerige'
}

